// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SubProductService = {};

SubProductService.postSubProduct = function (data) {
  return lossClient({
    url: "/SubProductType/add",
    method: "post",
    data: data,
  });
};

SubProductService.getSubProductList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductType/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

SubProductService.getSubProductApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  console.log(
    "🚀 ~ file: SubProductService.js:45 ~ userInputIndex:",
    userInputIndex
  );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  console.log(
    "🚀 ~ file: SubProductService.js:22 ~ decrementIndex:",
    decrementIndex
  );
  return lossClient({
    url:
      "/SubProductType/approvalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod +
      "&desc=" +
      userInput.desc,
    method: "get",
  });
};

SubProductService.putSubProductApproval = function (data) {
  // const requestDataValidation =
  //   data.approvalFlag.toLowerCase() == "return"
  //     ? { userId: data.userId }
  //     : data.approvalFlag.toLowerCase() == "reject"
  //     ? { userId: data.userId }
  //     : data.approvalFlag == "approve"
  //     ? { userId: data.userId, note: data.note }
  //     : { userId: data.userId };

  // let urlRequest;
  // const requestUrlValdiation =
  //   data.approvalFlag.toLowerCase() == "return"
  //     ? (urlRequest = "Return")
  //     : data.approvalFlag.toLowerCase() == "reject"
  //     ? (urlRequest = "Reject")
  //     : data.approvalFlag == "approve"
  //     ? (urlRequest = "Approve")
  //     : (urlRequest = "");

  console.log("🚀 ~ putSubProductApproval:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/SubProductType/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: { 
      Note: data.note,
      UserId: data.userId,
    },
  });
};

SubProductService.putSubProductRequest = function (data) {
  return lossClient({
    url: `/SubProductType/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: {
      Request: data.Request,
      Note: data.note,
      UserId: data.userId,
    },
  });
};

SubProductService.getSubProductDetail = function (data) {
  return lossClient({
    url: `/SubProductType/${data.id}`,
    method: "get",
  });
};

SubProductService.updateSubProduct = function (data) {
  console.log("🚀 ~ data:", data);
  const { id, ...requestBody } = data;
  console.log("🚀 ~ rest:", requestBody);
  // const requestBody = {
  //   TypeofUse: data.TypeOfUse,
  //   Description: data.description,
  //   userid: data.userid,
  // };
  return lossClient({
    url: "/SubProductType/Edit",
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestBody,
  });
};

SubProductService.deleteSubProduct = function (data) {
  return lossClient({
    url: "/SubProductType/Delete",
    method: "delete",
    headers: {
      "x-requestId": data.id,
    },
    data: data,
  });
};

export default SubProductService;
